import { Form, InputNumber, Modal, Select, Row, Col, Input } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCustomers } from "../../store/actions/customers";
import { getPackage } from "../../store/actions/package";

const { Option } = Select;
const { TextArea } = Input;

const WalletForm = ({ visible, onCreate, onCancel, record, businessType }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const customers = useSelector((state) => state.customers.list);
  const packages = useSelector((state) => state.packageReducer.list);

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        cusId: record.cusId,
        pId: record.pId,
        payType: record.payType,
        amt: record.amt,
        type: record.type,
        referral: record.referral,
        payNotes: record.payNotes,
        description: record.description,
      });
    } else {
      form.resetFields();
    }
  }, [record, form]);

  useEffect(() => {
    dispatch(getCustomers());
    dispatch(getPackage());
  }, [dispatch]);

  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <Modal
      open={visible}
      title={record ? "Update Wallet" : "Add Wallet"}
      okText="Submit"
      cancelText="Cancel"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            onCreate(values);
            form.resetFields();
          })
          .catch((info) => {
            console.log("Validate Failed:", info);
          });
      }}
      width={700}
      // height={750}
      centered
      bodyStyle={{ paddingTop: 20 }}
    >
      <Form
        {...formItemLayout}
        form={form}
        layout="vertical"
        name="package_form"
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              name="cusId"
              label="Customer"
              rules={[
                {
                  required: true,
                  message: "Please select at least one Customer",
                },
              ]}
            >
              <Select
                placeholder="Select Customer"
                style={{ width: "100%" }}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {customers.map((product) => (
                  <Select.Option key={product.id} value={product.id}>
                    {product.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name="pId"
              label="Package"
              rules={[
                {
                  required: true,
                  message: "Please select at least one Package",
                },
              ]}
            >
              <Select
                placeholder="Select Package"
                style={{ width: "100%" }}
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {packages.map((product) => (
                  <Select.Option key={product.id} value={product.id}>
                    {product.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="payType"
              label="Payment Mode"
              rules={[
                { required: true, message: "Please select a Payment Mode!" },
              ]}
            >
              <Select
                showSearch
                placeholder="Select a payment Mode"
                filterOption={(input, option) => {
                  // Convert both input and city name to lowercase for case-insensitive search
                  // return option.children.toLowerCase().includes(input.toLowerCase());
                }}
              >
                <Option value={"Razorpay"}>Razorpay</Option>
                <Option value={"Cash"}>Cash</Option>
                <Option value={"Bank"}>Bank</Option>
                <Option value={"NEFT"}>NEFT</Option>
                <Option value={"UPI"}>UPI</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="amt"
              label="Price"
              rules={[{ required: true, message: "Please enter the price!" }]}
            >
              <InputNumber
                placeholder="Enter Price"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="type"
              label="Type"
              rules={[{ required: true, message: "Please select a Type!" }]}
            >
              <Select
                showSearch
                placeholder="Select a type"
                filterOption={(input, option) => {
                  // Convert both input and city name to lowercase for case-insensitive search
                  // return option.children.toLowerCase().includes(input.toLowerCase());
                }}
              >
                <Option value={"CREDIT"}>CREDIT</Option>
                <Option value={"DEBIT"}>DEBIT</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name="referral"
              label="Referral"
              // rules={[{ required: true, message: "Please enter the price!" }]}
            >
              <Input placeholder="Enter Referral" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              name="payNotes"
              label="Payment Notes"
              // rules={[{ required: true, message: "Please enter the price!" }]}
            >
              <Input
                placeholder="Enter Payment Notes"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="description" label="Description">
              <TextArea rows={4} placeholder="Enter description..." />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default WalletForm;
